const SELECTORS = {
  container: '[data-video-container]',
  playButton: '[data-video-play]',
  video: 'video',
  swiper: '.swiper',
  activeSlide: '.swiper-slide-active',
  productGallery: '[data-product-gallery]',
};

const CSS_CLASSES = {
  opacity: 'opacity-0',
  pointerEvents: 'pointer-events-none',
};

const VIDEO_ATTRIBUTES = {
  autoplay: 'autoplay',
  controls: 'controls',
};

const OBSERVER_TIMEOUT_MS = 2000;

const initProductGalleryVideo = () => {
  const mainSwiper = document.querySelector(
    `${SELECTORS.swiper}[data-swiper-config*="thumbs"]`
  );
  if (!mainSwiper) return;

  const processedVideos = new WeakSet();

  const attachVideoHandlers = () => {
    const containers = document.querySelectorAll(SELECTORS.container);
    if (!containers.length) return;

    containers.forEach((container) => {
      const playBtn = container.querySelector(SELECTORS.playButton);
      const video = container.querySelector(SELECTORS.video);
      if (!playBtn || !video) return;

      // Skip if already processed
      if (processedVideos.has(video)) return;
      processedVideos.add(video);

      video.pause();
      video.currentTime = 0;
      video.removeAttribute(VIDEO_ATTRIBUTES.autoplay);
      video.removeAttribute(VIDEO_ATTRIBUTES.controls);

      let wasManuallyPlayed = false;

      const handlePlay = () => {
        wasManuallyPlayed = true;
        playBtn.classList.add(CSS_CLASSES.opacity, CSS_CLASSES.pointerEvents);
        video.setAttribute(VIDEO_ATTRIBUTES.controls, true);
        video.play();
      };

      const handlePause = () => {
        if (video.currentTime > 0 && !video.ended && wasManuallyPlayed) {
          playBtn.classList.remove(CSS_CLASSES.pointerEvents);
          requestAnimationFrame(() =>
            playBtn.classList.remove(CSS_CLASSES.opacity)
          );
        }
      };

      const handleEnded = () => {
        video.removeAttribute(VIDEO_ATTRIBUTES.controls);
        video.currentTime = 0;
        wasManuallyPlayed = false;
        playBtn.classList.remove(
          CSS_CLASSES.opacity,
          CSS_CLASSES.pointerEvents
        );
      };

      playBtn.addEventListener('click', handlePlay);
      video.addEventListener('pause', handlePause);
      video.addEventListener('ended', handleEnded);
    });

    const swiperInstances = document.querySelectorAll(SELECTORS.swiper);
    swiperInstances.forEach((swiperEl) => {
      if (!swiperEl.closest(SELECTORS.productGallery)) return;
      const swiper = swiperEl.swiper;
      if (!swiper) return;

      swiper.off('slideChange');
      swiper.on('slideChange', () => {
        swiperEl.querySelectorAll(SELECTORS.video).forEach((video) => {
          video.pause();
          video.removeAttribute(VIDEO_ATTRIBUTES.controls);

          const container = video.closest(SELECTORS.container);
          if (!container) return;
          const btn = container.querySelector(SELECTORS.playButton);
          if (btn) {
            btn.classList.remove(
              CSS_CLASSES.opacity,
              CSS_CLASSES.pointerEvents
            );
          }
        });
      });
    });
  };

  if (document.querySelector(SELECTORS.activeSlide)) {
    attachVideoHandlers();
    return;
  }

  const productGallery = document.querySelector(SELECTORS.productGallery);
  const observerTarget = productGallery || document.body;

  const state = {
    observer: null,
    timeoutId: null,
  };

  const cleanup = () => {
    if (state.observer) state.observer.disconnect();
    if (state.timeoutId) clearTimeout(state.timeoutId);
  };

  state.observer = new MutationObserver(() => {
    if (document.querySelector(SELECTORS.activeSlide)) {
      attachVideoHandlers();
      cleanup();
    }
  });

  state.observer.observe(observerTarget, { childList: true, subtree: true });

  state.timeoutId = setTimeout(() => {
    cleanup();
    attachVideoHandlers();
  }, OBSERVER_TIMEOUT_MS);
};

export default initProductGalleryVideo;
